import {
    HISTORY_COMPLETED,
    HISTORY_FAIL, HISTORY_FILTER,
    HISTORY_REQUEST,
    HISTORY_SUCCESS
} from '../actions/history';

const initialState = {
    historyData: [],
    historyDataAnswered: [],
    historyData1: {},
    filtered: [],
    completed: [],
    historyStatus:'',
    duration:0,
    page:1,
    count:0,
};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case HISTORY_REQUEST: {
            return {
                ...state,
                historyStatus: 'request',
                historyData: [],
            };
        }
        case HISTORY_SUCCESS: {
            return {
                ...state,
                historyStatus: 'success',
                historyData: action.payload.data.history1,
                historyDataAutoCall: action.payload.data.autoCall.response.numFound,
                historyDataAnswered: action.payload.data.ans.facet_counts.facet_fields.disposition,
                historyData1: action.payload.data.history1,
                filtered: action.payload.data.filteredSpeechBuddyArr,
                page:action.payload.data.page,
                count:action.payload.data.history1.response.numFound,
                duration:action.payload.data.history1.stats.stats_fields.duration.sum,
            };
        }

        case HISTORY_FILTER: {
            return {
                ...state,

                filtered: action.payload.data,

            };
        }
        case HISTORY_COMPLETED: {
            return {
                ...state,
                completed: [...state.completed,action.payload.data],
            };
        }
        case HISTORY_FAIL: {
            return {
                ...state,
                historyStatus: 'fail',
            };
        }

        default: {
            return {
                ...state,
            };
        }
    }
}
